import React from 'react';
import { Form, Row, Col, Button, Container } from 'react-bootstrap';

const OrderEntry = ({ mode = 'new', readOnly = false, order = {} }) => {
  const isViewMode = mode === 'view';
  const isReadOnly = readOnly || isViewMode;

  return (
    <Container>
      <Row className="mb-3">
        <Col>
          <h5>{order.isin}  {order.name}</h5>
        </Col>
      </Row>
      <Form>
        <Row className="mb-3">
          <Col>
            <Form.Group controlId="formNominal">
              <Form.Label>Nominal</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter nominal"
                defaultValue={order.nominal}
                readOnly={isReadOnly}
                style={{ backgroundColor: isReadOnly ? 'lightgrey' : 'yellow' }}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formCleanPrice">
              <Form.Label>Clean Price</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                defaultValue={order.cleanPrice}
                readOnly
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formHaircut">
              <Form.Label>Haircut</Form.Label>
              <Form.Control
                type="text"
                placeholder="0-100"
                defaultValue={order.haircut || 0}
                readOnly
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formStartCash">
              <Form.Label>startCash BHD</Form.Label>
              <Form.Control
                type="text"
                placeholder="-"
                defaultValue={order.startCash || 0}
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="formTerm">
              <Form.Label>Term</Form.Label>
              <Form.Control
                type="text"
                placeholder="Term"
                defaultValue={order.term}
                readOnly
                style={{ backgroundColor: '#F5CBA7' }}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formStartDate">
              <Form.Label>StartDate</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                defaultValue={order.start}
                readOnly
                style={{ backgroundColor: '#F5CBA7' }}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formEndDate">
              <Form.Label>EndDate</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                defaultValue={order.end}
                readOnly
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formDays">
              <Form.Label>Days</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                defaultValue={order.days}
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="formRepoRate">
              <Form.Label>Repo Rate</Form.Label>
              <Form.Control
                type="text"
                placeholder="%"
                defaultValue={order.repoRate}
                readOnly={isReadOnly}
                style={{ backgroundColor: isReadOnly ? 'lightgrey' : 'yellow' }}
              />
            </Form.Group>
          </Col>
        </Row>

        {!isViewMode && (
          <Row>
            <Col>
              <Button variant="success" block>Bid / Buy</Button>
            </Col>
            <Col>
              <Button variant="danger" block>Offer / Sell</Button>
            </Col>
          </Row>
        )}
      </Form>
    </Container>
  );
};

export default OrderEntry;
